import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_q6uy7uqavt: FaireBrandEntity = {
  token: "b_q6uy7uqavt",
  type: "brand",
  name: "Soli Echo",
  avatarUrl:
    "https://cdn.faire.com/fastly/52afe70c4d22f24aea7e15b1f6b462f670234dc11213206039b376f95e1c328d.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7e3c78ee63c17a92dc8d67def208e13964c28aedfc8f9924dbe49b5b7c0ea6d0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/52afe70c4d22f24aea7e15b1f6b462f670234dc11213206039b376f95e1c328d.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7e3c78ee63c17a92dc8d67def208e13964c28aedfc8f9924dbe49b5b7c0ea6d0.jpeg",
  location: "San Francisco, CA, USA",
  minimumOrderDollars: 100,
  rating: 3.9,
  reviewCount: 23,
  isInsider: true,
  description:
    "SoliEcho is a U.S.-based wholesale supplier of trend-driven women’s fashion.\n\nSince 2013, we have partnered with boutiques, online sellers, and stylists across the U.S., offering a curated selection of ready-to-ship styles ranging from everyday essentials to seasonal statement pieces.\n\nWe make sourcing simple and reliable so you can focus on growing your business. At SoliEcho, we believe wholesale should be simple, efficient, and built on trust.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:21.547Z",
    importedBy: "entity-db-cli",
  },
};
